<app-dropdown
  class="create-dropdown"
  [dropdownGroupedItems]="createActions"
  [triggerLabel]="'ACTION.CREATE' | translate"
  e2eId="create-dropdown"
>
  <ng-template
    let-dropdownItem="dropdownItem"
    let-closeCallback="closeCallback"
  >
    <i2g-router-link
      [label]="dropdownItem.label | translate"
      [route]="dropdownItem.route"
      [navigationExtras]="dropdownItem.navigationExtras"
      [trackingObject]="dropdownItem.trackingObject"
      [trackingAction]="dropdownItem.trackingAction"
      [e2eId]="dropdownItem.e2eId"
      class="create-dropdown-item"
      (linkClick)="onSelectAction.emit(dropdownItem); closeCallback()"
    >
    </i2g-router-link>
  </ng-template>
</app-dropdown>
